<template>
    <div>
        <b-modal
            no-fade
            id="modal-edit-programa"
            no-close-on-esc
            no-close-on-backdrop
            title="Alterar Programa"
            size="lg"
            @show="onShow()"
        >
            <div>
                <b-form-row>
                    <b-col lg="12">
                        <b-form-group label="Código" label-size="sm" label-for="programa_id">
                            <b-form-input
                                disabled
                                maxlength="50"
                                size="sm"
                                id="programa_id"
                                v-model="curPrograma.programa_id"
                                trim
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-form-row>
                <b-form-row>
                    <b-col lg="12">
                        <b-form-group label="Título" label-size="sm" label-for="titulo">
                            <b-textarea maxlength="5000" no-resize id="titulo" trim rows="3" v-model="curPrograma.titulo"></b-textarea>
                            <!-- <b-form-input
                                size="sm"
                                id="titulo"
                                maxlength="5000"
                                v-model="curPrograma.titulo"
                                trim
                            ></b-form-input> -->
                        </b-form-group>
                    </b-col>
                </b-form-row>
                <b-form-row>
                    <b-col lg="12">
                        <b-form-group label-size="sm" label="Cliente" label-for="cliente_id">
                            <v-select
                                id="cliente_id"
                                :options="combos.clientes"
                                label="cliente_id"
                                :reduce="(c) => c.cliente_id"
                                :clearable="false"
                                v-model="curPrograma.cliente_id"
                            >
                                <template v-slot:option="option">{{
                                    `${option.cliente_id} - ${option.razao_social}`
                                }}</template>
                                <template v-slot:selected-option="option">{{
                                    `${option.cliente_id} - ${option.razao_social}`
                                }}</template>
                                <template #no-options="{}">Sem dados a serem exibidos</template>
                            </v-select>
                        </b-form-group>
                    </b-col>
                </b-form-row>
                <b-form-row>
                    <b-col>
                        <b-form-group
                            label="Valor Empréstimo BID 2ª Moeda"
                            label-size="sm"
                            label-for="vl_emprestimo_bid_m2"
                        >
                            <b-form-input
                                size="sm"
                                id="vl_emprestimo_bid_m2"
                                v-model="curPrograma.vl_emprestimo_bid_m2"
                                trim
                                v-mask="{
                                    alias: 'numeric',
                                    autoUnmask: true,
                                    greedy: true,
                                    radixPoint: ',',
                                    groupSeparator: '.',
                                    digits: 2,
                                    digitsOptional: false,
                                    autoGroup: true,
                                    allowPlus: false,
                                    allowMinus: false,
                                    onUnMask: function(maskedValue) {
                                        var x = maskedValue.split(',');
                                        return x[0].replace(/\./g, '') + '.' + x[1];
                                    },
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group
                            label="Valor Empréstimo Contra-Partida 2ª Moeda"
                            label-size="sm"
                            label-for="vl_emprestimo_contrapartida_m2"
                        >
                            <b-form-input
                                size="sm"
                                id="vl_emprestimo_contrapartida_m2"
                                v-model="curPrograma.vl_emprestimo_contrapartida_m2"
                                trim
                                v-mask="{
                                    alias: 'numeric',
                                    autoUnmask: true,
                                    greedy: true,
                                    radixPoint: ',',
                                    groupSeparator: '.',
                                    digits: 2,
                                    digitsOptional: false,
                                    autoGroup: true,
                                    allowPlus: false,
                                    allowMinus: false,
                                    onUnMask: function(maskedValue) {
                                        var x = maskedValue.split(',');
                                        return x[0].replace(/\./g, '') + '.' + x[1];
                                    },
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-form-row>
                <!-- cotacoes -->
                <b-form-row>
                    <b-col>
                        <b-form-group label="Cotação BID" label-size="sm" label-for="cotacao_bid">
                            <b-form-input
                                size="sm"
                                id="cotacao_bid"
                                v-model="curPrograma.cotacao_bid"
                                trim
                                v-mask="{
                                    alias: 'numeric',
                                    autoUnmask: true,
                                    greedy: true,
                                    radixPoint: ',',
                                    groupSeparator: '.',
                                    digits: 4,
                                    digitsOptional: false,
                                    autoGroup: true,
                                    allowPlus: false,
                                    allowMinus: false,
                                    onUnMask: function(maskedValue) {
                                        var x = maskedValue.split(',');
                                        return x[0].replace(/\./g, '') + '.' + x[1];
                                    },
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group label="Cotação Contra-Partida" label-size="sm" label-for="cotacao_contrapartida">
                            <b-form-input
                                size="sm"
                                id="cotacao_contrapartida"
                                v-model="curPrograma.cotacao_contrapartida"
                                trim
                                v-mask="{
                                    alias: 'numeric',
                                    autoUnmask: true,
                                    greedy: true,
                                    radixPoint: ',',
                                    groupSeparator: '.',
                                    digits: 4,
                                    digitsOptional: false,
                                    autoGroup: true,
                                    allowPlus: false,
                                    allowMinus: false,
                                    onUnMask: function(maskedValue) {
                                        var x = maskedValue.split(',');
                                        return x[0].replace(/\./g, '') + '.' + x[1];
                                    },
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-form-row>

                <b-form-row>
                    <b-col>
                        <b-form-group label="Valor Empréstimo BID R$" label-size="sm" label-for="vl_emprestimo_bid">
                            <b-form-input
                                size="sm"
                                id="vl_emprestimo_bid"
                                v-model="VlBID"
                                trim
                                disabled
                                class="text-right"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group
                            label="Valor Empréstimo Contra-Partida R$"
                            label-size="sm"
                            label-for="vl_emprestimo_contrapartida"
                        >
                            <b-form-input
                                size="sm"
                                id="vl_emprestimo_contrapartida"
                                v-model="VlContraPartida"
                                trim
                                disabled
                                class="text-right"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-form-row>
            </div>
            <template v-slot:modal-footer>
                <b-button size="sm" @click="saveRecord()" variant="primary">
                    <i class="fas fa-check"></i> Gravar
                </b-button>
                <b-button size="sm" @click="() => $bvModal.hide('modal-edit-programa')">Cancelar</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { baseApiUrl, showError, formatMoney } from "@/global";
import axios from "axios";

export default {
    name: "ModalEditPrograma",
    props: {
        curPrograma: { type: Object, required: true },
    },
    computed: {
        VlBID: {
            get() {
                return formatMoney(
                    parseFloat(this.curPrograma.vl_emprestimo_bid_m2) * parseFloat(this.curPrograma.cotacao_bid),
                    2,
                    "",
                    ".",
                    ","
                );
            },
        },
        VlContraPartida: {
            get() {
                return formatMoney(
                    parseFloat(this.curPrograma.vl_emprestimo_contrapartida_m2) * parseFloat(this.curPrograma.cotacao_contrapartida),
                    2,
                    "",
                    ".",
                    ","
                );
            },
        },

    },
    data: function() {
        return {
            combos: {
                clientes: [],
            },
        };
    },
    methods: {
        saveRecord() {
            if ((this.curPrograma.titulo || "") === "") {
                this.$toasted.info("Digite o Título", {
                    duration: 4000,
                    keepOnHover: true,
                    className: "v-toasted-warning",
                });
                return false;
            }
            axios
                .put(`${baseApiUrl}/bid/programas/${this.curPrograma.programa_id}`, this.curPrograma)
                .then(() => {
                    this.$emit("updated");
                    this.$bvModal.hide("modal-edit-programa");
                })
                .catch(showError);
        },
        onShow() {},
        loadCombos() {
            // clientes
            axios
                .get(`${baseApiUrl}/clientes`)
                .then((resp) => {
                    this.combos.clientes = resp.data;
                })
                .catch(showError);
        },
    },
    mounted() {
        this.loadCombos();
    },
};
</script>

<style>
.vs__dropdown-toggle {
    padding: 0 !important;
}

.vs__selected {
    margin: 2px 2px 2px !important;
}
</style>
